import rivets from 'rivets'
import axios from 'axios'
import Preloader from './Preload'
import Helpers from '../helpers/Helpers'

class RecentlyViewed {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._limit = 7
        this._productComp = this._theme.getComponentsById('mainProduct')
        this._data = {
            loading: true,
            products: []
        }
    }

    async onInit () {
        let promiseArr = this.getProducts()
        await promiseArr
        this._data.loading = false
        this._rivetsBinders()
        rivets.bind(this._elem, this._data)
        this._elemsRendered()
    }

    _rivetsBinders () {
        rivets.formatters.json = (obj) => {
            return JSON.stringify(obj)
        }
        rivets.formatters.length = (arr) => {
            return arr ? arr.length : 0
        }
        rivets.formatters.gt = (number, val) => {
            return number > val
        }
        rivets.formatters.money = (value) => {
            return Helpers.formatMoney(value, this._theme.shopInfo.moneyFormat)
        }
    }

    static viewItem (handle) {
        let handles = localStorage.getItem('ESC_RECENTLY_VIEWED') ? JSON.parse(localStorage.getItem('ESC_RECENTLY_VIEWED')) : []
        if (handles.includes(handle)) {
            return false
        }
        handles.unshift(handle)
        if (handles.length > this._limit + 1) {
            handles.slice(0, this._limit + 1)
        }
        localStorage.setItem('ESC_RECENTLY_VIEWED', JSON.stringify(handles))
    }

    getProducts () {
        if (!localStorage.getItem('ESC_RECENTLY_VIEWED')) return
        this._data.loading = true
        let promiseArr = []
        let productHandles = JSON.parse(localStorage.getItem('ESC_RECENTLY_VIEWED'))
        for (let handle of productHandles) {
            if (this._productComp && this._productComp.product.handle === handle) continue
            if (promiseArr.length >= this._limit) continue
            promiseArr.push(new Promise(async (resolve, reject) => {
                try {
                    let request = await axios.get(`/products/${handle}?view=json`)
                    let product = request.data
                    product.url = `/products/${product.handle}`
                    this._data.products.push(product)
                    resolve()
                } catch (err) {
                    console.log('err')
                }
            }))
        }
        return Promise.all(promiseArr)
    }

    _elemsRendered () {
        new Preloader(this._theme, this._elem).onInit()
        let wishlistElems = this._elem.querySelectorAll('[data-wishlist-outer]')
        for (let elem of wishlistElems) {
            elem.setAttribute('data-app', 'eastsideco_wishlist')
            let inner = elem.querySelector('esc-wishlist-add-to-wishlist')
            inner.setAttribute(':product', inner.getAttribute('wishlist-product'))
        }
        window.esc_wishlist = window.esc_wishlist || []
        window.esc_wishlist.push(api => {
            wishlistElems = Array.apply(null, wishlistElems)
            api.emit('initialize', wishlistElems)
        })
    }
}

export default RecentlyViewed



// WEBPACK FOOTER //
// ./src/resources/scripts/components/RecentlyViewed.js